module.exports = __webpack_public_path__ + "static/img/logo2.ac1543be.png";